import {Injectable} from '@angular/core';
import {Storage} from '@ionic/storage';

@Injectable({
    providedIn: 'root'
})
export class InspirationService {
    static savedInspirationStorageKey = 'savedInspiration';

    constructor(private storage: Storage) {
    }


    async getSavedInspirations(): Promise<string[]> {
        let savedInspirationsString: string;
        try {
            await this.storage.ready();
            savedInspirationsString = await this.storage.get(InspirationService.savedInspirationStorageKey);
        } catch (error) {
            savedInspirationsString = localStorage.get(InspirationService.savedInspirationStorageKey);
        }

        if (!savedInspirationsString || savedInspirationsString === '') {
            return [];
        }

        return JSON.parse(savedInspirationsString).reverse();
    }

    async saveInspiration(id: string): Promise<void> {
        const savedInspirations = await this.getSavedInspirations();

        savedInspirations.push(id);

        try {
            await this.storage.ready();
            await this.storage.set(InspirationService.savedInspirationStorageKey, JSON.stringify([...new Set(savedInspirations)]));
        } catch (error) {
            localStorage.setItem(InspirationService.savedInspirationStorageKey, JSON.stringify([...new Set(savedInspirations)]));
        }
    }

    async removeInspiration(id: string): Promise<void> {
        const savedInspirations = (await this.getSavedInspirations())
            .filter(inspiration => inspiration !== id);

        try {
            await this.storage.ready();
            await this.storage.set(InspirationService.savedInspirationStorageKey, JSON.stringify([...new Set(savedInspirations)]));
        } catch (error) {
            localStorage.setItem(InspirationService.savedInspirationStorageKey, JSON.stringify([...new Set(savedInspirations)]));
        }
    }

    async hasInspirationSaved(id: string): Promise<boolean> {
        return (await this.getSavedInspirations()).includes(id);
    }

}
